import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200
        bg-gray-100 text-gray-600 hover:bg-gray-200
        dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
      title={`Theme: ${theme === "light" ? "Light" : "Dark (System)"} (click to change)`}
    >
      {theme === "light" ? <Sun size={18} /> : <Moon size={18} />}
      <span className="hidden sm:inline text-xs">{theme === "light" ? "Light" : "Dark"}</span>
    </button>
  );
}

export default ThemeToggle;
